<template>
    <div class="mcontent">
        <layout type="L_R"
         v-if="root.device!='phone'"
         :class="[root.device=='ipad'&&'mipad']"
        >
            <!-- <layout type="T_B"> -->
                <!-- <wrapper style="margin-top: -0.6vw;">
                    <cusbox txt="每月生产单计划达成率（模拟）">
                        <char1 :data="char1_data" :datelist="datelist" />
                    </cusbox>
                </wrapper> -->
                <!-- <wrapper flex='1.5'>
                    <cusbox txt="工种及工时占比（模拟）">
                        <layout type="L_R">
                            <char2
                                :data='char2data2'
                                title='平均工时占比'
                            />
                            <char2
                                :data='char2data3'
                                title='工种占比'
                            />
                        </layout>
                        <layout type="T_B">
                            <custitle
                                class="mytt"
                                txt='本月员工数'
                                :rightShow="false"
                            ></custitle>
                            <cchar2 :data="cchar2_data" :datelist="datelist2" tipname="生产员工总数"></cchar2>

                        </layout>

                    </cusbox>
                </wrapper> -->
            <!-- </layout> -->
            <layout type="T_B">
                <!-- <wrapper>
                    <cusbox txt='入库目标达成情况（模拟）'>
                        <layout type="L_R">
                            <layout
                                type="T_B"
                                class="mtt"
                                flex='1'
                            >

                                <div flex='1'>
                                    <cell type='bottom' class="more_device_txt1"> 年度入库目标</cell>
                                </div>
                                <div flex='2'>
                                    <cell>
                                        <div>
                                            <layout type="L_R">
                                                <cell><img src='@/assets/i5.png' /></cell>
                                                <cell>
                                                    <div class="more_device_txt2">
                                                        <div class="txt1">本年度总量</div>
                                                        <div class="txt2">221113</div>
                                                    </div>
                                                </cell>
                                            </layout>
                                        </div>
                                    </cell>
                                </div>

                            </layout>
                            <layout
                                type="T_B"
                                class="mtt"
                                flex='1'
                            >
                                <div flex='1'>
                                    <cell type='bottom'  class="more_device_txt1"> 月度入库目标达成</cell>
                                </div>
                                <div flex='2'>
                                    <cell>
                                        <div>
                                            <layout type="L_R">
                                                <cell><img src='@/assets/i6.png' /></cell>
                                                <cell>
                                                    <div  class="more_device_txt2">
                                                        <div class="txt1">本月总量</div>
                                                        <div class="txt2">221113</div>
                                                    </div>
                                                </cell>
                                            </layout>
                                        </div>
                                    </cell>
                                </div>
                            </layout>
                        </layout>
                        <layout type="L_R">
                            <char2
                                :data='char2data'
                                :rd="['0%', '45%']"
                            />
                            <char2
                                :data='char2data'
                                :rd="['0%', '45%']"
                            />
                        </layout>

                    </cusbox>
                </wrapper> -->
                <wrapper>
                    <cusbox txt="生产车间101组工序工时平衡表（模拟）">
                        <char3 :data="char3_data" :datelist="datelist3" />
                    </cusbox>
                </wrapper>
            </layout>
            <!-- <layout type="T_B">
                <wrapper>
                    <cusbox txt="本月个人效率排行TOP20（模拟）">
                        <itemlist
                            :count='5'
                            :columns='columns1'
                            :data='data1'
                            columnbg="#03083A"
                        />
                    </cusbox>
                </wrapper>
                <wrapper>
                    <cusbox txt="本月个人产能排行TOP20（模拟）" >
                        <itemlist
                            :count='5'
                            :columns='columns2'
                            :data='data2'
                            columnbg="#03083A"
                        />
                    </cusbox>
                </wrapper>
            </layout> -->
        </layout>

         <mobile class="device_phone ppd notransform" v-else>
              <!-- <div class="moblieline">
                   <cusbox txt="每月生产单计划达成率（模拟）">
                        <char1 :data="char1_data" :datelist="datelist" />
                    </cusbox>
              </div> -->
               <!-- <div class="moblieline h750" >
                   <cusbox txt="工种及工时占比（模拟）">
                        <layout type="T_B" flex=1.5>
                            <char2
                                :data='char2data2'
                                title='平均工时占比'
                            />
                            <char2
                                :data='char2data3'
                                title='工种占比'
                            />
                        </layout>
                        <layout type="T_B"  flex=1.5>
                          
                            <div flex=1>
                            <cchar2 title='本月员工数' :data="cchar2_data" :datelist="datelist2" tipname="生产员工总数"></cchar2>
                             </div>
                        </layout>

                    </cusbox>
               </div> -->
                <!-- <div class="moblieline h450">
 <cusbox txt='入库目标达成情况（模拟）'>
                        <layout type="T_B">
                            <layout
                                type="T_B"
                                class="mtt"
                                flex='1'
                            >
                                <div flex='1'>
                                    <cell type='bottom' > 年度入库目标</cell>
                                </div>
                                <div flex='2'>
                                    <cell>
                                        <div>
                                            <layout type="L_R">
                                                <cell><img src='@/assets/i5.png' /></cell>
                                                <cell>
                                                    <div>
                                                        <div class="txt1">本年度总量</div>
                                                        <div class="txt2">221113</div>
                                                    </div>
                                                </cell>
                                            </layout>
                                        </div>
                                    </cell>
                                </div>
                                  <div flex='2'> 
                            <char2
                                :data='char2data'
                                :rd="['0%', '50%']"
                            />
                                  </div>
                            </layout>
                            <layout
                                type="T_B"
                                class="mtt"
                                flex='1'
                            >
                                <div flex='1'>
                                    <cell type='bottom'> 月度入库目标达成</cell>
                                </div>
                                <div flex='2'>
                                    <cell>
                                        <div>
                                            <layout type="L_R">
                                                <cell><img src='@/assets/i6.png' /></cell>
                                                <cell>
                                                    <div>
                                                        <div class="txt1">本月总量</div>
                                                        <div class="txt2">221113</div>
                                                    </div>
                                                </cell>
                                            </layout>
                                        </div>
                                    </cell>
                                </div>
                                <div flex='2'> 
  <char2
                                :data='char2data'
                                :rd="['0%', '50%']"
                            />
                                </div>
                                            
                            </layout>
                        </layout>
                        

                    </cusbox>
                </div> -->
                <div class="moblieline">
 <cusbox txt="生产车间101组工序工时平衡表（模拟）">
                        <char3 :data="char3_data" :datelist="datelist3" rotate="30"/>
                    </cusbox>
                </div>
                <!-- <div class="moblieline">
  <cusbox txt="本月个人效率排行TOP20（模拟）">
                        <itemlist
                            :count='5'
                            :columns='cols_1'
                            :data='data1'
                            columnbg="#03083A"
                        />
                    </cusbox>
                </div> -->
                 <!-- <div class="moblieline">
                  <cusbox txt="本月个人产能排行TOP20（模拟）" >
                        <itemlist
                            :count='5'
                            :columns='columns2'
                            :data='data2'
                            columnbg="#03083A"
                        />
                    </cusbox>
                </div> -->
         </mobile>
    </div>
</template>
<script>
import layout from "@/components/cuscom/layout.vue";
import wrapper from "@/components/cuscom/wrapper.vue";
import cusbox from "@/components/vip/cusbox";
import char1 from "./report/char1";
import char2 from "./report/char2";
import char3 from "./report/char3";
import cchar2 from "../common/report/char2";
import custitle from "@/components/vip/custitle";
import cell from "@/components/cuscom/cell.vue";
import itemlist from "@/components/cuscom/itemlist"
import {cols_1,cols_2} from "./device/phone_column.js"
export default {
  components: {
    layout,
    cusbox,
    wrapper,
    char1,
    char2,
    char3,
    cchar2,
    custitle,
    cell,
    itemlist,
  },
     inject:['root'],
  data() {
    return {
      cols_1,
      char2data: [
        {
          value: 2,
          name: "已完成",
          itemStyle: { color: "#4346D3" },
          showvalue: "110s"
        },
        {
          value: 3,
          name: "未完成",
          itemStyle: { color: "#2D99FF" },
          showvalue: "110s"
        },
      ],
      char2data2: [
        {
          value: 2,
          name: "检验",
          itemStyle: { color: "#4346D3" },
          showvalue: "110s"
        },
        {
          value: 3,
          name: "剪裁",
          itemStyle: { color: "#2D99FF" },
          showvalue: "110s"
        }, {
          value: 3,
          name: "车缝",
          itemStyle: { color: "#4346D3" },
          showvalue: "19s"
        },
         {
          value: 3,
          name: "包装",
          itemStyle: { color: "#2D99FF" },
          showvalue: "30s"
        },
        {
          value: 3,
          name: "后整",
          itemStyle: { color: "#4346D3" },
          showvalue: "118s"
        },
        {
          value: 3,
          name: "工艺",
          itemStyle: { color: "#2D99FF" },
          showvalue: "220s"
        },
      ],
      char2data3: [
        {
          value: 2,
          name: "检验",
          itemStyle: { color: "#4346D3" },
          showvalue: "10人"
        },
        {
          value: 3,
          name: "剪裁",
          itemStyle: { color: "#2D99FF" },
          showvalue: "20人"
        }, {
          value: 3,
          name: "车缝",
          itemStyle: { color: "#4346D3" },
          showvalue: "40人"
        },
         {
          value: 3,
          name: "包装",
          itemStyle: { color: "#2D99FF" },
          showvalue: "5人"
        },
        {
          value: 3,
          name: "后整",
          itemStyle: { color: "#4346D3" },
          showvalue: "10人"
        },
        {
          value: 3,
          name: "工艺",
          itemStyle: { color: "#2D99FF" },
          showvalue: "5人"
        },
      ],
      columns1: [
        {
          title: "排名",
          key: "number",
          align: "center",
           width:'2.5vw',
         
        },
        {
          title: "姓名",
          key: "name",
          align: "center"
        },
        {
          title: "线组/车间",
          key: "thread",
          align: "center",
           width:'6vw',
        },
        {
          title: "岗位",
          key: "post",
          align: "center"
        },
        {
          title: "标准工时 s",
          key: "standard",
          align: "center"
        },
        {
          title: "实际工时 s",
          key: "actual",
          align: "center"
        },
        {
          title: "效率",
          key: "efficiency",
          align: "center"
        }
      ],
       columns2: [
        {
          title: "排名",
          key: "number",
          align: "center",
         
        },
        {
          title: "姓名",
          key: "name",
          align: "center"
        },
        {
          title: "线组/车间",
          key: "thread",
          align: "center"
        },
        {
          title: "岗位",
          key: "post",
          align: "center"
        },
        {
          title: "产能（件）",
          key: "capacity",
          align: "center"
        },
        {
          title: "上月排名",
          key: "ranking",
          align: "center"
        },
      
      ],
      data1: [],
      data2: [],
      char1_data:{},
      datelist:[],
      cchar2_data:{},
      datelist2:[],
      char3_data:{},
      datelist3:[],
      api:this.$apis["digitalproduction_1"]
    };
  },
 
    mounted(){
        this.data1=[{
          number: 1,
          name: "王晓哲1",
          thread: "生产101组",
          post: "车缝",
          standard: 210,
          actual: 190,
          efficiency: "140%"
        },{
          number: 2,
          name: "王晓哲2",
          thread: "生产101组",
          post: "车缝",
          standard: 210,
          actual: 190,
          efficiency: "140%"
        },{
          number: 3,
          name: "王晓哲3",
          thread: "生产101组",
          post: "车缝",
          standard: 210,
          actual: 190,
          efficiency: "140%"
        },{
          number: 4,
          name: "王晓哲4",
          thread: "生产101组",
          post: "车缝",
          standard: 210,
          actual: 190,
          efficiency: "140%"
        },{
          number: 5,
          name: "王晓哲5",
          thread: "生产101组",
          post: "车缝",
          standard: 210,
          actual: 190,
          efficiency: "140%"
        },{
          number: 6,
          name: "王晓哲6",
          thread: "生产101组",
          post: "车缝",
          standard: 210,
          actual: 190,
          efficiency: "140%"
        }]

        this.data2=[{
            number:1,
            name:"蒋国一",
            thread:"生产104组",
            post:"车缝",
            capacity:2110,
            ranking:2
        },{
            number:2,
            name:"蒋国一2",
            thread:"生产104组",
            post:"车缝",
            capacity:2110,
            ranking:2
        },{
            number:3,
            name:"蒋国一3",
            thread:"生产104组",
            post:"车缝",
            capacity:2110,
            ranking:2
        },{
            number:4,
            name:"蒋国一4",
            thread:"生产104组",
            post:"车缝",
            capacity:2110,
            ranking:2
        },{
            number:5,
            name:"蒋国一5",
            thread:"生产104组",
            post:"车缝",
            capacity:2110,
            ranking:2
        },{
            number:6,
            name:"蒋国一6",
            thread:"生产104组",
            post:"车缝",
            capacity:2110,
            ranking:2
        }]

        this.api.get1().then(res=>{       
                    var obj={orders:[],date:[],overdue:[],rate:[],sale:[]}
                    for(var i=0;i<res.data.list.length;i++){
                        obj.orders.push(res.data.list[i].orders)
                        obj.date.push(res.data.list[i].date)
                        obj.overdue.push(res.data.list[i].overdue)
                        obj.rate.push(res.data.list[i].rate)
                        obj.sale.push(res.data.list[i].sale)
                    }
                    this.char1_data=obj
                    this.datelist=obj.date
        }) 
        this.api.get2().then(res=>{       
          var obj={date:[],saleTotal:[]}
          for(var i=0;i<res.data.list.length;i++){
            obj.date.push(res.data.list[i].date)
            obj.saleTotal.push(res.data.list[i].saleTotal)
          }
          this.cchar2_data=obj
          this.datelist2=obj.date
        })
        this.api.get3().then(res=>{        
          var obj={name:[],actual:[],average:[]}
          for(var i=0;i<res.data.list.length;i++){
            obj.name.push('员工'+i)
            obj.actual.push(res.data.list[i].actual)
            obj.average.push(res.data.list[i].average)
          }
          this.char3_data=obj
          this.datelist3=obj.name
        })
    }
};
</script>
<style lang='scss'>
@import './device/phone.scss';
</style>
<style lang="scss" scoped>
.mipad{
   .more_device_txt1{
     font-size: 32px;
   }
   .more_device_txt2{
     .txt1{
       font-size: 24px !important;
     }
     .txt2{
       font-size: 40px;
       font-weight: bold;
     }    
   }
}
.mcontent {
  color: #fff;
  height: 100%;
  display: flex;
  .mytt {
    height: 30px;
  }
  .mtt {
    .txt1 {
      font-size: 12px;
      height: 30px;
    }                                                        
   .txt1 {
      font-size: 12px;
      height: 30px;
    }
    img {
      margin-right: 10px;
      width: 40px;
      height: 40px;
      display: block;
    }
  }
}


</style>